var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"header",staticStyle:{"background-color":"rgba(206, 220, 236)"}},[_c('div',{staticClass:"prompt-28 text-center pt-9"},[_vm._v(" "+_vm._s(_vm.$t('message.formHeader.header'))+" "+_vm._s(_vm.openingDate)+" - "+_vm._s(_vm.closingDate)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }